<script>
export default {
  name: "SetCampus",
  data() {
    return {
      campus: this.$store.getters["data/getCampus"],
      campuses: [],
      realCampus: [],
      isAdmin: this.$store.state.decrypt.isAdmin(),
      dus: [],
    };
  },
  methods: {
    hideModal() {
      this.$bvModal.hide("set-campus-modal");
    },
    async getDUs($event) {
      await this.$store
        .dispatch("deliveryunit/GetDeliveryUnitByCampus", $event)
        .then((response) => {
          this.dus = response.data;
        })
        .catch((error) => {
          this.showToast("Something went wrong", "error");
        });
    },
    async dropData() {
      let campusSelected = this.realCampus.find((item) => item.id == this.campus);
      if (this.isAdmin) {
        this.pageLoader(true);
        await this.getDUs(campusSelected.id);
        this.pageLoader(false);
        this.$store.commit("data/changeDU", this.dus[0]);
        this.$emit("changeDU", this.dus[0]);
      } else {
        if (localStorage.getItem("duAccess")) {
          let duAccess = JSON.parse(localStorage.getItem("duAccess"));
          let findDU = duAccess.find((item) => item.campusId == campusSelected.id);
          if (findDU) {
            this.$store.commit("data/changeDU", findDU);
            this.$emit("changeDU", findDU);
          }
        }
      }
      this.$store.commit("data/changeCampus", campusSelected);
      this.$emit("changeCampus", campusSelected);
      this.$bvModal.hide("set-campus-modal");
    },
  },
  created() {
    var campuses = [{ text: `Select ${this.GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}...`, value: 0, disabled: true }];
    this.realCampus = [];
    this.$store.state.decrypt.campusAccessList().forEach((item) => {
      campuses.push({ value: item.Id, text: item.CampusName });
      this.realCampus.push({
        id: item.Id,
        campusName: item.CampusName,
        shortName: item.ShortName,
        isExternal: item.IsExternal,
      });
    });
    this.campuses = campuses;
    this.campus = this.$store.getters["data/getCampus"].id;
  },
};
</script>

<template>
  <b-modal id="set-campus-modal"
           :title="`Set ${GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}`"
           size="sm"
           title-class="font-18"
           hide-footer
           no-close-on-backdrop>
    <div class="mb-3">
      <label for="name">{{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}} </label>
      <b-form-select v-model="campus"
                     :options="campuses"
                     class="form-select"></b-form-select>
    </div>
    <div class="modal-footer">
      <button type="button"
              class="btn btn-primary"
              @click="dropData">Set {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}</button>
      <button type="button"
              class="btn btn-link"
              @click="hideModal">Close</button>
    </div>
  </b-modal>
</template>
